import React, { useState } from 'react';
import { DatePicker } from '@ds/react-components';
import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import { ReactComponent as CalendarIcon } from 'assets/icons/ic-calendar-day.svg';
import { IconButton, InputAdornment } from '@material-ui/core';

const TextFieldComponent = (props) => {
  const { InputProps, value, clearDate } = props;

  return (
    <TextField
      {...props}
      InputProps={{
        ...InputProps,
        readOnly: true,
        endAdornment: (
          <InputAdornment>
            {clearDate && value ? (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  clearDate && clearDate();
                }}>
                <ClearIcon />
              </IconButton>
            ) : null}
            <CalendarIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

const SuspensionDatePicker = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <DatePicker
      open={open}
      onClose={() => setOpen(false)}
      onClick={(e) => {
        setOpen(!open);
      }}
      TextFieldComponent={TextFieldComponent}
      {...props}
    />
  );
};

export default SuspensionDatePicker;
